import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function ChatBody({ children }: Props) {
  return <div className="h-full rounded-[0.625rem] flex flex-col w-full">{children}</div>;
}
